// @flow

import styled, { css } from 'styled-components';

export const Button = styled.button`
  border: none;
  background: none;
  cursor: not-allowed;
  outline: none;

  text-align: center;
  text-decoration: none;

  position: relative;
  display: inline-block;
  padding: 0.85em 1em;

  ::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    opacity: 0;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1);
  }

  transition: filter 200ms cubic-bezier(0, 0, 0.2, 1);

  ${({ disabled = false }) => !disabled && css`
    cursor: pointer;
    :hover, :focus {
      filter: brightness(115%);
      ::before {
        opacity: .1;
      }
    }
    &:active {
      box-shadow: none;
    }
  `}
  
  ${({ type = 'default', outlineColor }) => css`
    border: 2px solid ${type === 'default' ? 'transparent' : outlineColor};

    ::before {
      background-color: ${type === 'default' ? 'black' : outlineColor};
    }
  `}

  ${({ type }) => type === 'primary' && css`
    background: rgb(35, 151, 212);  
    color: white;
    border-radius: 6px;
  `}

  ${({ block }) => block && css`
    display: block;
    width: 100%;
  `}
`;
